import React from "react";

const ActivityTimeline = ({ stats }) => (
   <div className="content-card">
      <div className="card-header">
         <h3 className="card-title">
            <i className="bi bi-clock-history"></i>
            Activity Timeline
         </h3>
      </div>
      <div className="timeline-stats">
         <div className="stat-item">
            <div
               style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0.75rem",
                  borderBottom: "1px solid var(--border-color)",
               }}
            >
               <div>
                  <p
                     style={{
                        margin: "0 0 0.25rem 0",
                        color: "#6c757d",
                        fontSize: "0.875rem",
                     }}
                  >
                     Today
                  </p>
                  <p style={{ margin: 0, fontWeight: "bold" }}>
                     {stats?.submissions_today || 0} submissions
                  </p>
               </div>
               <i className="bi bi-calendar-day text-primary"></i>
            </div>
         </div>
         <div className="stat-item">
            <div
               style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0.75rem",
                  borderBottom: "1px solid var(--border-color)",
               }}
            >
               <div>
                  <p
                     style={{
                        margin: "0 0 0.25rem 0",
                        color: "#6c757d",
                        fontSize: "0.875rem",
                     }}
                  >
                     This Week
                  </p>
                  <p style={{ margin: 0, fontWeight: "bold" }}>
                     {stats?.submissions_this_week || 0} submissions
                  </p>
               </div>
               <i className="bi bi-calendar-week text-info"></i>
            </div>
         </div>
         <div className="stat-item">
            <div
               style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0.75rem",
               }}
            >
               <div>
                  <p
                     style={{
                        margin: "0 0 0.25rem 0",
                        color: "#6c757d",
                        fontSize: "0.875rem",
                     }}
                  >
                     This Month
                  </p>
                  <p style={{ margin: 0, fontWeight: "bold" }}>
                     {stats?.submissions_this_month || 0} submissions
                  </p>
               </div>
               <i className="bi bi-calendar-month text-success"></i>
            </div>
         </div>
      </div>
   </div>
);

export default ActivityTimeline;
